import { createId } from "@paralleldrive/cuid2";

const keyForFunnel = (funnelId: string, persistenceScope?: string) =>
  persistenceScope
    ? `landingPageFormSession:${persistenceScope}:${funnelId}`
    : `formFunnelSession:${funnelId}`;

export function readFormFunnelSessionId(
  funnelId: string,
  persistenceScope?: string
): string | undefined {
  if (typeof window === "undefined") return undefined;
  return window.sessionStorage.getItem(keyForFunnel(funnelId, persistenceScope)) ?? undefined;
}

export function getOrCreateFormFunnelSessionId(
  funnelId: string,
  persistenceScope?: string
): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const key = keyForFunnel(funnelId, persistenceScope);
  const existing = readFormFunnelSessionId(funnelId, persistenceScope);
  if (existing) {
    return existing;
  }

  const sessionId = createId();
  window.sessionStorage.setItem(key, sessionId);
  return sessionId;
}
